import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../components/Navbars/Navbar';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { app } from '../../config';
import getPermById from '../../hooks/getPermById';
import useFetchPermissions from '../../hooks/fetchPermissions';

const EditPermission = () => {
  const { t } = useTranslation(['common']);
  const [formfields, setFormFields] = useState({ permId: '', label: '',module:'', action: '' });
  const navigate = useNavigate();
  const p=useFetchPermissions();
  console.log(p);
  const permissions=p.response?p.response:" ";
  console.log(permissions);
  let permId = JSON.parse(localStorage.getItem('permissionId'));
  console.log(permId);
  let res = getPermById(permId);
  console.log(res);
  let permObj = {};
  let checked = false;
  if (res.response) permObj = res.response;
  const handleChange = (e) => {
    const value = e.target.value;
    setFormFields({ ...formfields, [e.target.name]: value });
  };
  console.log(permObj);
  const handleCheckChange = (e) => {
    console.log(e.target.checked);
    let setChecked = '1';
    if (!e.target.checked) setChecked = '0';
    setFormFields({ ...formfields, is_active: setChecked });
  };
  const handleSubmit = async () => {
    console.log(formfields);
    const temp = { ...formfields };
    console.log('🚀 ~ file: AddOrganization.jsx:26 ~ handleSubmit ~ temp', temp);
    let Objkeys = Object.keys(temp);
    console.log('🚀 ~ file: EditOrg.js:25 ~ handleSubmit ~ Objkeys', Objkeys);
    Objkeys.forEach((element) => {
      if (temp[element] === 0) temp[element] = temp[element];
      else if (!temp[element]) temp[element] = permObj[element];
    });
    console.log(temp);
    try {
      const res = await axios.post(`${app.URL}/perm/updateperm/${permObj.permId}`, temp);
      console.log('🚀 ~ file: EditRole.js:49 ~ handleSubmit ~ res', res);
      console.log('Data response' + res.data);

      window.alert(res.data);
      if (res.data) navigate('/permission/view');
    } catch (err) {
      console.log(err);
      if (err) console.log(err.response.data.message);
      else retrun;
    }
  };

  return (
    <div class='container colorbg' style={{ maxWidth: '100%' }}>
      <div class='row'>
        <Navbar />
      </div>
      <div class='row '>
        <div class='col-sm-4' style={{ width: '25%', marginLeft: '-10px' }}>
          <SideBar4 />
        </div>
        <div class='col-lg-6 mt-4 '>
          <div class='card'>
            <div class='card-body p-5'>
              <h2 class='text-uppercase text-center mb-5 fw-bold fs-5'>{t('Edit Role')}</h2>

              <form>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t('Id')}
                  </label>
                  <input type='text' name='permId' disabled defaultValue={permObj ? permObj.permId : ' '} id='form3Example1cg' class='form-control form-control-lg' />
                </div>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t('Label')}
                  </label>
                  <input type='text' name='label' id='form3Example1cg' defaultValue={permObj ? permObj.label : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t('Module')}
                  </label>
                  <input type='text' name='action' id='form3Example1cg' defaultValue={permObj ? permObj.module : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t('Action')}
                  </label>
                  <input type='text' name='action' id='form3Example1cg' defaultValue={permObj ? permObj.action : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>
                <div class='d-flex justify-content-center'>
                  <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
                    {t('Edit')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPermission;
